import { IApplicationState } from '../../types/redux';

export const selectUnfinishedAnketaModalListNumber = (state: IApplicationState): number | null =>
  state.calculator.unfinishedAnketaModal.listNumber;
